import {FallbackProps} from 'react-error-boundary';
import {Button} from '@material-ui/core';
import './component-fallback.scss';

export function ComponentFallback({error, resetErrorBoundary}: FallbackProps) {
  return (
    <div role='alert' className='qep-renderError'>
      <div className='qep-renderError__message'>
        There was a component error.<br/>
        Click the button to try reloading.<br/>
        If this fails, please restart the application.
      </div>
      <div className='qep-renderError__error'>{error.name}: {error.message}</div>
      <Button className='qep-renderError__button' role='button' variant='outlined' onClick={resetErrorBoundary}>
        Try Again
      </Button>
    </div>
  );
}
